import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import styled from 'styled-components'
import { Button, Modal } from 'wix-style-react'

import { auth } from 'constants/firebase'
import Header from '../dashboard/DashboardHeader'
import Layout from '../shared/Layout'
import { media, ALMOST_WHITE } from 'components/styles'
import FancyInput from 'components/signin/FancyInput'
import { changeEmailPassword } from 'controllers/auth'
import { saveUserAttributes } from 'controllers/user'
import MessageBoxFunctionalLayout from 'components/shared/MessageBoxFunctionalLayout'
import history from 'components/history'

const PageContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background-color: ${ALMOST_WHITE};
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 18px;`}
`
const InputContainer = styled.div`
  margin-bottom: 2em;
  text-align: center;
`
const FormContainer = styled.div`
  margin-top: 5em;
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c9d7df;
  border-radius: 3px;
  box-sizing: border-box;
`
const Form = styled.div`
  width: 236px;
  height: 220px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const ModalContent = styled.div`
  height: 15em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  align-self: center;
`

class Account extends Component {

  constructor (props) {
    super(props)
    this.state = {
      modalVisible: false
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!auth.currentUser || auth.currentUser.isAnonymous) history.push('/auth')
    const name = _.get(nextProps, 'user.fullName', '')
    if (this.nameInput) this.nameInput.setValue(name)
    const email = _.get(nextProps, 'user.email', '')
    if (this.emailInput) this.emailInput.setValue(email)
    const companyName = _.get(nextProps, 'user.companyName', '')
    if (this.companyNameInput) this.companyNameInput.setValue(companyName)
  }

  validateEmail (email) {
    const re = new RegExp('[^@]+@[^@]+\\.[^@]+')
    return re.test(email)
  }

  onNameInputMounted = (ref) => {
    this.nameInput = ref
    const name = _.get(this.props, 'user.fullName')
    if (ref && name) ref.setValue(name)
  }

  renderNameInput = () => {
    return (
      <InputContainer>
        <FancyInput
          placeholder='Name'
          ref={this.onNameInputMounted}
        />
      </InputContainer>
    )
  }

  onEmailInputMounted = (ref) => {
    this.emailInput = ref
    const email = _.get(this.props, 'user.email', '')
    if (ref) ref.setValue(email)
  }

  renderEmailInput = () => {
    const isPassword = this.isPasswordAuth()
    if (isPassword) {
      return (
        <InputContainer>
          <Button
            height='small'
            theme='transparentblue'
            onClick={this.openModal}
          >
            Change email/password
          </Button>
        </InputContainer>
      )
    } else {
      return (
        <InputContainer>
          <FancyInput
            placeholder='Email'
            ref={this.onEmailInputMounted}
            onBlurValidation={value => this.validateEmail(value)}
            onBlurValidationMessage='That’s not a valid email address'
          />
        </InputContainer>
      )
    }
  }

  onCompanyInputMounted = (ref) => {
    this.companyNameInput = ref
    const companyName = _.get(this.props, 'user.companyName', '')
    if (ref) ref.setValue(companyName)
  }

  renderCompanyInput = () => {
    return (
      <InputContainer>
        <FancyInput
          placeholder='Company Name'
          ref={this.onCompanyInputMounted}
        />
      </InputContainer>
    )
  }

  providerId = () => _.get(auth, 'currentUser.providerData.0.providerId')

  isPasswordAuth = () => this.providerId() === 'password'

  checkFormIsValid = () => {
    let formIsValid = true
    const inputs = [
      this.nameInput,
      this.companyNameInput
    ]

    if (this.emailInput) inputs.push(this.emailInput)

    inputs.forEach((input) => {
      if (!input.state.valid) {
        formIsValid = false
        return
      }
      if (input.value() === '') {
        formIsValid = false
        input.setupValidState({
          valid: false,
          invalidMessage: 'This field is required'
        })
      }
    })
    return formIsValid
  }

  apply = () => {
    const { dispatch, user } = this.props
    const isValid = this.checkFormIsValid()
    const newEmail = this.emailInput ? this.emailInput.value() : null
    let notChanged = true
    const newName = this.nameInput.value()
    const newCompanyName = this.companyNameInput.value()
    notChanged = notChanged && newName === user.fullName
    notChanged = notChanged && newCompanyName === user.companyName
    if (newEmail) notChanged = notChanged && newEmail === user.email
    if (isValid && !notChanged) {
      dispatch(saveUserAttributes(user.id, newName, newCompanyName, newEmail))
    }
  }

  closeModal = () => this.setState({ modalVisible: false })
  openModal = () => this.setState({ modalVisible: true })

  checkFieldIsNotEmpty = (input) => {
    const v = input.value()
    if (v === '') {
      input.setupValidState({
        valid: false,
        invalidMessage: 'This field is required'
      })
      return false
    }
    return true
  }

  modalApply = () => {
    let formIsValid = true
    formIsValid = formIsValid && this.currentPasswordInput.state.valid && this.checkFieldIsNotEmpty(this.currentPasswordInput)
    formIsValid = formIsValid && this.newEmailInput.state.valid && this.checkFieldIsNotEmpty(this.newEmailInput)
    formIsValid = formIsValid && this.newPasswordInput.state.valid
    formIsValid = formIsValid && this.newPasswordInput2.state.valid

    const newPassword = this.newPasswordInput.value()
    const newPassword2 = this.newPasswordInput2.value()
    if (newPassword !== '' && newPassword !== newPassword2) {
      formIsValid = false
      this.newPasswordInput2.setupValidState({
        valid: false,
        invalidMessage: 'Password does not match'
      })
    }

    if (formIsValid) {
      const { dispatch } = this.props
      dispatch(changeEmailPassword(this.newEmailInput.value(), this.currentPasswordInput.value(), newPassword))
      this.closeModal()
    }
  }

  onCurrentPasswordMounted = (ref) => { this.currentPasswordInput = ref }
  onNewEmailMounted = (ref) => {
    if (ref) {
      this.newEmailInput = ref
      ref.setValue(this.props.user.email)
    }
  }
  onNewPasswordMounted = (ref) => { this.newPasswordInput = ref }
  onNewPasswordMounted2 = (ref) => { this.newPasswordInput2 = ref }

  validatePassword = (p) => {
    return p === '' || p.length >= 6
  }

  renderModalContent = () => {
    return (
      <ModalContent>
        <InputContainer>
          <FancyInput
            type='password'
            placeholder='Current password'
            ref={this.onCurrentPasswordMounted}
          />
        </InputContainer>

        <InputContainer>
          <FancyInput
            placeholder='New email'
            ref={this.onNewEmailMounted}
            onBlurValidation={value => this.validateEmail(value)}
            onBlurValidationMessage='That’s not a valid email address'
          />
        </InputContainer>

        <InputContainer>
          <FancyInput
            type='password'
            placeholder='New password'
            ref={this.onNewPasswordMounted}
            onBlurValidation={this.validatePassword}
            onBlurValidationMessage='Password must be at least 6 characters'
          />
        </InputContainer>

        <InputContainer>
          <FancyInput
            type='password'
            placeholder='Retype new password'
            ref={this.onNewPasswordMounted2}
            onBlurValidation={this.validatePassword}
            onBlurValidationMessage='Password must be at least 6 characters'
          />
        </InputContainer>

      </ModalContent>
    )
  }

  renderPasswordModal () {
    const { modalVisible } = this.state
    return (
      <Modal zIndex={100} isOpen={modalVisible} contentLabel=''>
        <MessageBoxFunctionalLayout
          theme='blue'
          title='Changing email/password'
          confirmText='Ok'
          cancelText='Cancel'
          onOk={this.modalApply}
          onCancel={this.closeModal}
        >
          {this.renderModalContent()}
        </MessageBoxFunctionalLayout>
      </Modal>
    )
  }

  renderButton = () => {
    return (
      <ButtonContainer>
        <Button onClick={this.apply}> Save </Button>
      </ButtonContainer>
    )
  }

  renderMain () {
    return (
      <PageContainer>
        <FormContainer>
          <Form>
            {this.renderNameInput()}
            {this.renderCompanyInput()}
            {this.renderEmailInput()}
            {this.renderButton()}
          </Form>
        </FormContainer>
        {this.state.modalVisible ? this.renderPasswordModal() : null}
      </PageContainer>
    )
  }

  render () {
    return (
      <Layout
        header={<Header />}
        main={this.renderMain()}
      />
    )
  }
}

Account.propTypes = {
  user: PropTypes.object.isRequired // eslint-disable-line react/no-unused-prop-types
}

const mapStateToProps = (state) => (
  {
    authData: state.authData,
    user: state.user
  })

export default connect(mapStateToProps)(Account)



// WEBPACK FOOTER //
// ./src/components/pages/Account.js